import { reactive } from 'vue';

export const criarFornecedor = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdfornecedor: 0,
        nmfornecedor: '',
        cpfcnpj: '',
        ie: 0,
        cnae: 0,
        endereco: '',
        nmendereco: 0,
        complemento: '',
        bairro: '',
        cep: '',
        fone: '',
        ckativo: 'S',
        idlogin: 0,
        idusuario: 0
    });
};